module.exports = __webpack_public_path__ + "static/img/logo-white.091c75b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-white.png
// module id = wYO/
// module chunks = 1